import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.match";
//
//
//
//
//
//

import $ProductionProgress from '@/pages/mes/components/productionProgress';
export default {
  name: 'Common31',
  props: {
    rowData: {
      type: [Object, null],
      default: null
    },
    fieldData: {
      type: [Object, null],
      default: null
    }
  },
  methods: {
    handleClick: function handleClick() {
      var code = this.fieldData['jumpUrl'].match(/\{[^\}]+\}/);
      if (code !== null) {
        code = code[0].split("{")[1].split("}")[0];
      } else {
        code = "id";
      }
      $ProductionProgress({
        id: this.rowData[code]
        // // 资料打印-箱唛打印用purchaseOrderId其他页面用id
        // id: [this.rowData.purchaseOrderId || this.rowData.id].toString()
      });
    }
  }
};